document.addEventListener('DOMContentLoaded', function() {
    const breadcrumbs = document.querySelector('#breadcrumbs');
    if (!breadcrumbs) {
        return;
    }

    const nextElement = breadcrumbs.nextElementSibling?.querySelector(
            'div:first-child') ??
        breadcrumbs.nextElementSibling;
    if (!nextElement) {
        return;
    }

    const darkClasses = [
        'has-primary-darker-background-color',
        'has-primary-dark-background-color',
        'has-primary-background-color',
        'has-primary-light-background-color',
        'has-secondary-darkest-background-color',
        'has-secondary-darker-background-color',
        'has-secondary-dark-background-color',
        'has-secondary-background-color',
    ];

    const hasDarkClass = darkClasses.some(cls => nextElement.classList.contains(
        cls));

    if (hasDarkClass) {
        breadcrumbs.classList.add('text-white');
    } else {
        breadcrumbs.classList.remove('text-white');
    }
});
//# sourceMappingURL=breadcrumbs.js.map
